export default "__VITE_ASSET__46c8c50f__"